import { Heading, P, Section, Wrapper } from 'components/base';
import PropTypes from 'prop-types';
import React from 'react';
import { qaWrapper } from './QABlock.module.scss';

const QABlock = ({ data, theme, padding, wrapperSize, heading }) => {
  const createMarkup = item => ({ __html: item });
  return (
    <Section padding={padding} theme={theme}>
      <Wrapper size={wrapperSize}>
        <Heading Tag="h2" size="L" center marginBottom="M" bold>
          {heading}
        </Heading>
        <ul className={qaWrapper}>
          {data.map((item, i) => (
            <li key={i}>
              <Heading Tag="h3" bold size="SM" marginBottom="Xxs">
                {item.q}
              </Heading>
              <P><div dangerouslySetInnerHTML={createMarkup(item.a)}></div></P>
            </li>
          ))}
        </ul>
      </Wrapper>
    </Section>
  );  
}
QABlock.propTypes = {
  data: PropTypes.array.isRequired,
  theme: PropTypes.string,
  padding: PropTypes.string,
  wrapperSize: PropTypes.string,
  heading: PropTypes.string
};

QABlock.defaultProps ={
  padding: 'L',
  theme: null,
  wrapperSize: 'M',
  heading: '常見問題'
}

export default QABlock;